// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeddingPlannerDashboard_pageHeader__cRv-e {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.WeddingPlannerDashboard_pageHeader__cRv-e h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 .WeddingPlannerDashboard_date__58nLk {
  display: flex;
  align-items: center;
  gap: 4px;
}
.WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 .WeddingPlannerDashboard_date__58nLk img,
.WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 .WeddingPlannerDashboard_date__58nLk svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 .WeddingPlannerDashboard_date__58nLk span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

@media (max-width: 767px) {
  .WeddingPlannerDashboard_pageHeader__cRv-e {
    padding: 16px;
  }
  .WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 {
    gap: 8px;
  }
  .WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .WeddingPlannerDashboard_pageHeader__cRv-e .WeddingPlannerDashboard_right__jmY65 .WeddingPlannerDashboard_date__58nLk span {
    display: none;
  }
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt {
  padding: 0 20px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingDashboardInner__L1xV6 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 40px 0;
}
@media (max-width: 768px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingDashboardInner__L1xV6 {
    grid-template-columns: repeat(1, 1fr);
  }
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_yourParty__4BbKy .WeddingPlannerDashboard_partyCards__Yoeq8 > div {
  padding: 0 !important;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingDashboardHeading__muD68 {
  font: var(--h6);
  font-weight: 600;
  color: var(--primary-Text);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_yourWeddingDayTimeline__-05MJ {
  margin-top: 1em;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_yourWeddingDayTimeline__-05MJ .WeddingPlannerDashboard_calendarHeading__aHf5I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_yourWeddingDayTimeline__-05MJ .WeddingPlannerDashboard_calendarHeading__aHf5I .WeddingPlannerDashboard_calendarHeadingRight__PMhvC img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: block;
  border: 2px solid var(--success);
  object-fit: cover;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_yourWeddingDayTimeline__-05MJ .WeddingPlannerDashboard_calendarWrp__\\+eU2F {
  margin-top: 20px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk {
  padding: 22px 0;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_taskList__FcGk7 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_taskList__FcGk7 li {
  padding: 7.5px;
  border-radius: 8px;
  border: 1px solid var(--border);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_budgetRow__ar\\+TN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_budgetRow__ar\\+TN .WeddingPlannerDashboard_chartWrp__DRFt1 {
  max-width: 275px;
  width: 100%;
  position: relative;
}
@media (max-width: 1200px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_budgetRow__ar\\+TN .WeddingPlannerDashboard_chartWrp__DRFt1 {
    max-width: 200px;
  }
}
@media (max-width: 500px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_budgetRow__ar\\+TN {
    flex-direction: column;
  }
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_categoryBreakdown__upyod {
  flex: 1 1;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_categoryBreakdown__upyod .WeddingPlannerDashboard_cardTitle__HpWEp {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  margin-bottom: 12px;
}
@media (max-width: 500px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_categoryBreakdown__upyod {
    width: 100%;
    flex: 1 1;
  }
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_allocatedCol__ANS5S {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 12px 0;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_allocatedCol__ANS5S .WeddingPlannerDashboard_allocatedAmount__7MHkn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_allocatedCol__ANS5S .WeddingPlannerDashboard_allocatedAmount__7MHkn h5 {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--primary-Text);
  text-wrap: nowrap;
  width: fit-content;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_allocatedCol__ANS5S .WeddingPlannerDashboard_allocatedAmount__7MHkn h6 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  text-wrap: nowrap;
  width: fit-content;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B {
  margin-bottom: 16px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B .WeddingPlannerDashboard_guestsCardWrp__boBWX {
  padding: 16px;
  border-radius: var(--border-radius);
  background-color: #EDF7EE;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B .WeddingPlannerDashboard_guestsCardWrp__boBWX h5 {
  font: var(--h6);
  font-weight: 600;
  color: var(--black);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B .WeddingPlannerDashboard_guestsCardWrp__boBWX .WeddingPlannerDashboard_info__IPyw- h6 {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 4px;
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B .WeddingPlannerDashboard_guestsCardWrp__boBWX .WeddingPlannerDashboard_info__IPyw- span {
  font: var(--body-font-four);
  color: var(--primary-Text);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_businessProfileProgressCard__NWk7H {
  padding: 15px;
  margin: 0;
  border: 1px solid var(--border);
  border-radius: var(--border-radius-large);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_businessProfileProgressCard__NWk7H .WeddingPlannerDashboard_businessProfileProgressTitle__HxR-p {
  font: var(--body-font-two);
  font-weight: 600;
  margin: 0 0 12px 0;
  color: var(--primary-Text);
}
.WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_businessProfileProgressCard__NWk7H .WeddingPlannerDashboard_businessProfileProgressPercentage__quc\\+I {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--brand);
  text-transform: capitalize;
}

@media (max-width: 991px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt {
    padding: 0 16px;
  }
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingDashboardInner__L1xV6 {
    grid-template-columns: repeat(1, 1fr);
    gap: 15px;
    padding: 20px 0;
  }
}
@media (max-width: 425px) {
  .WeddingPlannerDashboard_weddingDashboard__ujJtt .WeddingPlannerDashboard_weddingCardsWrp__yWVuk .WeddingPlannerDashboard_guestsWrp__N546B .WeddingPlannerDashboard_guestsCardWrp__boBWX {
    padding: 7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/Vendor/WeddingPlannerDashboard.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC;IACC,aAAA;EAJA;EAMA;IACC,QAAA;EAJD;EAMC;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAJF;EAQE;IACC,aAAA;EANH;AACF;AAYA;EACC,eAAA;AAVD;AAYC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AAVF;AAYE;EAND;IAOE,qCAAA;EATD;AACF;AAeG;EACC,qBAAA;AAbJ;AAkBC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;AAhBF;AAmBC;EACO,eAAA;AAjBR;AAmBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAjBH;AAoBI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;AAlBL;AAuBE;EACC,gBAAA;AArBH;AAyBC;EACC,eAAA;AAvBF;AAyBE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAvBH;AAyBG;EACC,cAAA;EACA,kBAAA;EACA,+BAAA;AAvBJ;AA2BE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAzBH;AA2BG;EACC,gBAAA;EACA,WAAA;EACA,kBAAA;AAzBJ;AA2BI;EALD;IAME,gBAAA;EAxBH;AACF;AA2BG;EAhBD;IAiBE,sBAAA;EAxBF;AACF;AA4BE;EACC,SAAA;AA1BH;AA4BG;EAEC,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AA3BJ;AA8BG;EAXD;IAYE,WAAA;IACA,SAAA;EA3BF;AACF;AA8BE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AA5BH;AA8BG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA5BJ;AA8BI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AA5BL;AA+BI;EACC,4BAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AA7BL;AAqCE;EACC,mBAAA;AAnCH;AAqCG;EACC,aAAA;EACA,mCAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAnCJ;AAqCI;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AAnCL;AAuCK;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AArCN;AAwCK;EACC,2BAAA;EACA,0BAAA;AAtCN;AA8CC;EACC,aAAA;EACA,SAAA;EACA,+BAAA;EACA,yCAAA;AA5CF;AA8CE;EACC,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AA5CH;AA+CE;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AA7CH;;AAkDA;EACC;IACC,eAAA;EA/CA;EAiDA;IACC,qCAAA;IACA,SAAA;IACA,eAAA;EA/CD;AACF;AAmDA;EAKI;IACC,YAAA;EArDH;AACF","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageHeader {\r\n\t\tpadding: 16px;\r\n\r\n\t\t.right {\r\n\t\t\tgap: 8px;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 35px;\r\n\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t\ttext-align: center;\r\n\t\t\t}\r\n\r\n\t\t\t.date {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tdisplay: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.weddingDashboard {\r\n\tpadding: 0 20px;\r\n\r\n\t.weddingDashboardInner {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\tgap: 24px;\r\n\t\tpadding: 40px 0;\r\n\r\n\t\t@media (max-width: 768px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n\r\n\t.yourParty {\r\n\r\n\t\t.partyCards {\r\n\t\t\t&>div {\r\n\t\t\t\tpadding: 0 !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.weddingDashboardHeading {\r\n\t\tfont: var(--h6);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.yourWeddingDayTimeline {\r\n        margin-top: 1em;\r\n\r\n\t\t.calendarHeading {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 15px;\r\n\r\n\t\t\t.calendarHeadingRight {\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 34px;\r\n\t\t\t\t\theight: 34px;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\tborder: 2px solid var(--success);\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.calendarWrp {\r\n\t\t\tmargin-top: 20px;\r\n\t\t}\r\n\t}\r\n\r\n\t.weddingCardsWrp {\r\n\t\tpadding: 22px 0;\r\n\r\n\t\t.taskList {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 8px;\r\n\t\t\tlist-style: none;\r\n\r\n\t\t\tli {\r\n\t\t\t\tpadding: 7.5px;\r\n\t\t\t\tborder-radius: 8px;\r\n\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.budgetRow {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 15px;\r\n\r\n\t\t\t.chartWrp {\r\n\t\t\t\tmax-width: 275px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tposition: relative;\r\n\r\n\t\t\t\t@media (max-width: 1200px) {\r\n\t\t\t\t\tmax-width: 200px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 500px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t}\r\n\r\n\t\t}\r\n\r\n\t\t.categoryBreakdown {\r\n\t\t\tflex: 1;\r\n\r\n\t\t\t.cardTitle {\r\n\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin-bottom: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t@media (max-width: 500px) {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tflex: 1;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.allocatedCol {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 12px;\r\n\t\t\tmargin: 12px 0;\r\n\r\n\t\t\t.allocatedAmount {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\ttext-wrap: nowrap;\r\n\t\t\t\t\twidth: fit-content;\r\n\t\t\t\t}\r\n\r\n\t\t\t\th6 {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\ttext-wrap: nowrap;\r\n\t\t\t\t\twidth: fit-content;\r\n\t\t\t\t}\r\n\r\n\t\t\t}\r\n\r\n\r\n\t\t}\r\n\r\n\t\t.guestsWrp {\r\n\t\t\tmargin-bottom: 16px;\r\n\r\n\t\t\t.guestsCardWrp {\r\n\t\t\t\tpadding: 16px;\r\n\t\t\t\tborder-radius: var(--border-radius);\r\n\t\t\t\tbackground-color: #EDF7EE;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 8px;\r\n\r\n\t\t\t\th5 {\r\n\t\t\t\t\tfont: var(--h6);\r\n\t\t\t\t\tfont-weight: 600;\r\n\t\t\t\t\tcolor: var(--black);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.info {\r\n\t\t\t\t\th6 {\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.businessProfileProgressCard {\r\n\t\tpadding: 15px;\r\n\t\tmargin: 0;\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: var(--border-radius-large);\r\n\r\n\t\t.businessProfileProgressTitle {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tmargin: 0 0 12px 0;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\r\n\t\t.businessProfileProgressPercentage {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--brand);\r\n\t\t\ttext-transform: capitalize;\r\n\t\t}\t\t\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.weddingDashboard {\r\n\t\tpadding: 0 16px;\r\n\r\n\t\t.weddingDashboardInner {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\tgap: 15px;\r\n\t\t\tpadding: 20px 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.weddingDashboard {\r\n\t\t.weddingCardsWrp {\r\n\t\t\t.guestsWrp {\r\n\r\n\t\t\t\t.guestsCardWrp {\r\n\t\t\t\t\tpadding: 7px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `WeddingPlannerDashboard_pageHeader__cRv-e`,
	"right": `WeddingPlannerDashboard_right__jmY65`,
	"date": `WeddingPlannerDashboard_date__58nLk`,
	"weddingDashboard": `WeddingPlannerDashboard_weddingDashboard__ujJtt`,
	"weddingDashboardInner": `WeddingPlannerDashboard_weddingDashboardInner__L1xV6`,
	"yourParty": `WeddingPlannerDashboard_yourParty__4BbKy`,
	"partyCards": `WeddingPlannerDashboard_partyCards__Yoeq8`,
	"weddingDashboardHeading": `WeddingPlannerDashboard_weddingDashboardHeading__muD68`,
	"yourWeddingDayTimeline": `WeddingPlannerDashboard_yourWeddingDayTimeline__-05MJ`,
	"calendarHeading": `WeddingPlannerDashboard_calendarHeading__aHf5I`,
	"calendarHeadingRight": `WeddingPlannerDashboard_calendarHeadingRight__PMhvC`,
	"calendarWrp": `WeddingPlannerDashboard_calendarWrp__+eU2F`,
	"weddingCardsWrp": `WeddingPlannerDashboard_weddingCardsWrp__yWVuk`,
	"taskList": `WeddingPlannerDashboard_taskList__FcGk7`,
	"budgetRow": `WeddingPlannerDashboard_budgetRow__ar+TN`,
	"chartWrp": `WeddingPlannerDashboard_chartWrp__DRFt1`,
	"categoryBreakdown": `WeddingPlannerDashboard_categoryBreakdown__upyod`,
	"cardTitle": `WeddingPlannerDashboard_cardTitle__HpWEp`,
	"allocatedCol": `WeddingPlannerDashboard_allocatedCol__ANS5S`,
	"allocatedAmount": `WeddingPlannerDashboard_allocatedAmount__7MHkn`,
	"guestsWrp": `WeddingPlannerDashboard_guestsWrp__N546B`,
	"guestsCardWrp": `WeddingPlannerDashboard_guestsCardWrp__boBWX`,
	"info": `WeddingPlannerDashboard_info__IPyw-`,
	"businessProfileProgressCard": `WeddingPlannerDashboard_businessProfileProgressCard__NWk7H`,
	"businessProfileProgressTitle": `WeddingPlannerDashboard_businessProfileProgressTitle__HxR-p`,
	"businessProfileProgressPercentage": `WeddingPlannerDashboard_businessProfileProgressPercentage__quc+I`
};
export default ___CSS_LOADER_EXPORT___;
